import { render, staticRenderFns } from "./PerPageCount.vue?vue&type=template&id=9df6155c&scoped=true&"
import script from "./PerPageCount.vue?vue&type=script&lang=js&"
export * from "./PerPageCount.vue?vue&type=script&lang=js&"
import style0 from "./PerPageCount.vue?vue&type=style&index=0&id=9df6155c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df6155c",
  null
  
)

export default component.exports